package org.example.project.service

import androidx.compose.runtime.compositionLocalOf

val LocalScreenInternalTitleVisible = compositionLocalOf { true }
